// Used in add-edit-student, assign-review-select-classes, teacher-class-form, grade-assignments, assets.effect.ts,
// page-header, section-label, assign-review-global-settings, evaluate-assignment-details-header

import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "generic-dialog",
    templateUrl: "./generic-dialog.component.html",
    styleUrls: ["./generic-dialog.component.scss"],
    standalone: false
})
export class GenericDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<GenericDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    close(): void {
        this.dialogRef.close(1);
    }
}
